var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uplus-back",attrs:{"id":"uplus"}},[_c('div',{staticClass:"uplus-content"},[_c('div',{staticClass:"left"},[_vm._v("用心连接，U+服务")]),_vm._v(" "),_c('a',{staticClass:"aboutUPlus",attrs:{"href":_vm.jumpLinkObj.uPlusURL,"target":"_blank","rel":"noreferrer,noopener"}},[_vm._v("About U+")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8915ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/gtn/components/uplus/connect.vue
// module id = null
// module chunks = 